import $ from 'jquery';
import Mailcheck from 'mailcheck';

// CopyPaste from node_modules/mailcheck
// jQuery plugin initialization
$.fn.mailcheck = function (opts) {
  var self = this;
  if (opts.suggested) {
    var oldSuggested = opts.suggested;
    opts.suggested = function (result) {
      oldSuggested(self, result);
    };
  }

  if (opts.empty) {
    var oldEmpty = opts.empty;
    opts.empty = function () {
      oldEmpty.call(null, self);
    };
  }

  opts.email = this.val();
  Mailcheck.run(opts);
};

const MailcheckStella = {
  check: function () {
    var domain = $(this).data('domain');
    var domains = Mailcheck.defaultDomains.slice(0);
    domains.push(domain);
    $(this).mailcheck({
      domains: domains,
      suggested: function (element, suggestion) {
        $('p#email_hint').html(
          'Did you mean <strong><span class="track-suggestion">' +
            suggestion.full +
            '</span></strong>?',
        );
      },
      empty: function (/*element*/) {
        $('p#email_hint').html('');
      },
    });
  },
};

export default MailcheckStella;
